import store from '@/store'

window.setWindowDesignRelatorio = async function (designer) {
  if (store && store.state && store.state.relatorio && store.state.relatorio.editaRelatorio) {
    if (store.state.relatorio.editaRelatorio.report) designer.setReport(store.state.relatorio.editaRelatorio.report)
    else designer.newReport()
  }
}

window.windowDesignRelatorioSave = function (report) {
  store.dispatch('relatorio/saveRelatorio', report)
}

window.windowDesignRelatorioExit = function (report) {
  store.dispatch('relatorio/closeRelatorio')
}
